import { OPEN_ALERT } from '../constants/index'

export const openAlert = (payload: Object) => {
  return {
    type: OPEN_ALERT,
    payload
  }
}

